<div id="selection-popup" class="warning-popup">
    <h2 class="m-b-5" mat-dialog-title>Actuación Comentarios</h2>
    <div mat-dialog-content id="leave-popup-fields">
      <div>
        <form [formGroup]="ActionEditForm">
          <mat-form-field>
            <textarea matInput rows="7" placeholder="Comentarios" formControlName="Text"></textarea>
            <mat-error
              *ngIf="ActionEditForm.get('Text') && ActionEditForm.get('Text').invalid">
              <span *ngIf="ActionEditForm.get('Text').errors.required" class="validation-span">Obligatorio</span>
            </mat-error>
          </mat-form-field>
        </form>
      </div>
      <div class="text-a-r p-t-5">
        <button mat-raised-button color="accent" class="m-r-15" (click)="SaveActionText()">Consultar</button>
        <button mat-raised-button color="warn" (click)="Close()">Cancelar</button>
      </div>
    </div>
  </div>